import {  Component,  OnInit,ChangeDetectorRef } from '@angular/core';
import {  SelectItem,  SortEvent} from 'primeng/api';
import {  FacilityService,  EquipmentService} from 'src/app/services';
import {  EquipmentInfo, AccessUserInfo, UserLocationFacility} from 'src/app/models';

@Component({
  selector: 'bart-mass-transfer',
  templateUrl: './mass-transfer.component.html',
  styleUrls: ['./mass-transfer.component.scss']
})

export class MassTransferComponent implements OnInit {
  firstLeft = 0;
  firstRight = 0;
  userDetail: any = null;
  public strEquipmentRightStatus: string[];
  public strEquipmentLeftStatus: string[];
  public facilityObj: object;
  public massTransferObjLeft: object;
  public massTransferObjRight: object;
  public transferEquipmentLeftObj: object;
  public transferEquipmentRightObj: object;
  loading = false;
  displayModal: boolean = false;
  Content: string;
  Header: string = "Success";
  public isPaginatorVisible: boolean = false;
  //Facility Left
  public userFacilitiesLeft: SelectItem[];
  public selectedFacilityMasterIdLeft: number;
  public selectedEquipmentIdLeft: any[];
  public selectedEquipmentIdsLeft: [];
  public strEquipmentLeftIdList: string;
  selectedEquipmentsL: EquipmentInfo[];
  public dataSourceMassTransferLeft: EquipmentInfo[] = [];
  public cols: any[];
  //Facility Right
  public userFacilitiesRight: SelectItem[];
  public selectedFacilityMasterIdRight: number;
  public selectedEquipmentIdRight: any[];
  public strEquipmentRightIdList: string;
  selectedEquipmentsR: EquipmentInfo[];
  public dataSourceMassTransferRight: EquipmentInfo[] = [];

  constructor(private facilityService: FacilityService, private equipmentService: EquipmentService, private changeDetectorRef: ChangeDetectorRef) {
    this.userDetail = AccessUserInfo.getUserInfo();
  }

  ngOnInit() {
    this.getUserFacilities();
    this.cols = [{
        field: 'EquipmentID',
        header: 'Equipment Id',
        display: 'none'
      },
      {
        field: 'Status',
        header: 'Status',
        display: 'table-cell'
      },
      {
        field: 'ManufacturerName',
        header: 'Manufacturer',
        display: 'table-cell'
      },
      {
        field: 'ModelNumber',
        header: 'Model',
        display: 'table-cell'
      },
      {
        field: 'EquipmentSubTypeDescription',
        header: 'Sub-Type',
        display: 'table-cell'
      },
      {
        field: 'EquipmentSerialNumber',
        header: 'SN / IntID',
        display: 'table-cell'
      },
      {
        field: 'MPI',
        header: 'MPI',
        display: 'table-cell'
      },
    ];
  }

  public getUserFacilities() {
      this.loading = true;
      this.facilityService.getUserLocationFacilities(this.userDetail.userName,(facilities:UserLocationFacility[])=>
      {
        this.userFacilitiesLeft = []
        if(facilities)
        {
          this.userFacilitiesLeft.push({
            label: '- Pick a Location -',
            value: 0
          });
          for (let c of facilities) {
            this.userFacilitiesLeft.push({
              label: c.FacilityDisplayName,
              value: c.FacilityMasterID
            });
            
          }
          this.changeDetectorRef.detectChanges();
        }
        this.loading = false;
      });
    
  }

  FacilityEquipmentMassTransferLeft(equipObj: object) {

    if (equipObj !== null) {   
      this.dataSourceMassTransferLeft=[];
      this.equipmentService.getFacilityEquipmentMassTransfer(JSON.stringify(equipObj))
        .subscribe((EquipmentMassTransferResponse: any) => {
          this.dataSourceMassTransferLeft=[]
          if (EquipmentMassTransferResponse.facilityEquipment.length > 0) {
            this.dataSourceMassTransferLeft = EquipmentMassTransferResponse.facilityEquipment;
            this.isPaginatorVisible = true;         
            this.changeDetectorRef.detectChanges();
          } else {
            this.dataSourceMassTransferLeft = [];         
            this.changeDetectorRef.detectChanges();
          }
        }, (respose: Response) => {         
          this.dataSourceMassTransferLeft=[];
          this.changeDetectorRef.detectChanges();
          // handle error here
        });
    }
  }

  FacilityEquipmentMassTransferRight(equipObj: object) {

    if (equipObj !== null) {     
      this.dataSourceMassTransferRight=[];
      this.equipmentService.getFacilityEquipmentMassTransfer(JSON.stringify(equipObj))
        .subscribe((EquipmentMassTransferResponse: any) => {
         
          if (EquipmentMassTransferResponse.facilityEquipment.length > 0) {
            this.dataSourceMassTransferRight = EquipmentMassTransferResponse.facilityEquipment;          
            this.changeDetectorRef.detectChanges();
          } else {
            this.dataSourceMassTransferRight = [];          
            this.changeDetectorRef.detectChanges();
          }
        }, (respose: Response) => {         
          this.dataSourceMassTransferRight=[];
          this.changeDetectorRef.detectChanges();
          // handle error here
        });
    }
  }

  GetFacilityEquipmentMassTransferLeft() {
    
    if (this.selectedFacilityMasterIdLeft > 0) {
      this.massTransferObjLeft = {
        "GETFACILITYEQUIPMENTMASSTRANSFER": {
          "facilityMasterId": this.selectedFacilityMasterIdLeft
        },
      };
      this.FacilityEquipmentMassTransferLeft(this.massTransferObjLeft);
    }
    else
    {
      this.dataSourceMassTransferLeft = [];
    }    
  }

  GetFacilityEquipmentMassTransferRight() {
    
    if (this.selectedFacilityMasterIdRight > 0) {
      this.massTransferObjRight = {
        "GETFACILITYEQUIPMENTMASSTRANSFER": {
          "facilityMasterId": this.selectedFacilityMasterIdRight,
        },
      };
      this.FacilityEquipmentMassTransferRight(this.massTransferObjRight);    
    }
    else
    {
      this.dataSourceMassTransferRight = []; 
    }
  }

  //--Sorting------
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

  //#######################################Transfer Equipment Right Start #######################################   

  public transferEquipmentRight() {
    
    // Left Equipments-->>  Right Equipments   

    if (this.selectedFacilityMasterIdLeft === undefined || this.selectedFacilityMasterIdLeft==null ||  this.selectedFacilityMasterIdLeft==0) {
      this.Header = "Error";
      this.Content = "Please select a location to transfer from.";
      this.displayModal = true
      return false;
    }

    if (this.selectedFacilityMasterIdRight === undefined || this.selectedFacilityMasterIdRight==null || this.selectedFacilityMasterIdRight==0) {
      this.Header = "Error";
      this.Content = "Please select a location to transfer to.";
      this.displayModal = true
      return false;
    }

    if(this.selectedEquipmentIdLeft  === undefined || this.selectedEquipmentIdLeft  == null || this.selectedEquipmentIdLeft.length  == 0) 
    {
      this.Header = "Error";
      this.Content = "Please select Equipment for transfer.";
      this.displayModal = true
      return false;  
    }

    this.strEquipmentLeftStatus = Array.prototype.map.call(this.selectedEquipmentIdLeft, function (item) {
    return item.Status;
    }).join(",")

    if (this.strEquipmentLeftStatus.includes("Off Line Storage")) {

      this.Header = "Error";
      this.Content = "Equipment with off line storage status cannot be transferred.";
      this.displayModal = true
      return false;
    }

    this.strEquipmentLeftIdList = Array.prototype.map.call(this.selectedEquipmentIdLeft, function (item) {
      return item.EquipmentId;
    }).join(",");
    this.transferEquipmentLeftObj = {
      "TRANSFEREQUIPMENT": {
        "equipmentId": this.strEquipmentLeftIdList,
        "toFacId": this.selectedFacilityMasterIdRight,
        "userid": this.userDetail.userId
      }
    };

    this.transferEquipment(this.transferEquipmentLeftObj);
    this.selectedEquipmentIdLeft=null;
  }
  //####################################### Transfer Equipment Right End  ######################################

  //####################################### Transfer Equipment Left Start ######################################
  public transferEquipmentLeft() {
    
    //Right Equipments-->Left Equipments
    if (this.selectedFacilityMasterIdRight === undefined || this.selectedFacilityMasterIdRight==null || this.selectedFacilityMasterIdRight==0) {
      this.Header = "Error";
      this.Content = "Please select a location to transfer from.";
      this.displayModal = true
      return false;
    }
    if (this.selectedFacilityMasterIdLeft === undefined || this.selectedFacilityMasterIdLeft==null || this.selectedFacilityMasterIdLeft==0) {
      this.Header = "Error";
      this.Content = "Please select a location to transfer to.";
      this.displayModal = true
      return false;
    }

    if(this.selectedEquipmentIdRight  === undefined || this.selectedEquipmentIdRight  == null || this.selectedEquipmentIdRight.length==0) 
    {
      this.Header = "Error";
      this.Content = "Please select Equipment for transfer.";
      this.displayModal = true
      return false;  
    }

    this.strEquipmentRightStatus = Array.prototype.map.call(this.selectedEquipmentIdRight, function (item) {
      return item.Status;
    }).join(",")

    if (this.strEquipmentRightStatus.includes("Off Line Storage")) {

      this.Header = "Error";
      this.Content = "Equipment with off line storage status cannot be transferred.";
      this.displayModal = true
      return false;
    }

    this.strEquipmentRightIdList = Array.prototype.map.call(this.selectedEquipmentIdRight, function (item) {
      return item.EquipmentId;
    }).join(",");

    this.transferEquipmentRightObj = {
      "TRANSFEREQUIPMENT": {
        "equipmentId": this.strEquipmentRightIdList,
        "toFacId": this.selectedFacilityMasterIdLeft,
        "userid": this.userDetail.userId
      }
    };
    this.transferEquipment(this.transferEquipmentRightObj); //Left side transfer.
    this.selectedEquipmentIdRight=null;
  }

  //####################################### Transfer Equipment Left End  #######################################

  //####################################### Validation ##########################################################
  isMassTransferValid: boolean;

  //####################################### End Validation ##########################################################

  public transferEquipment(facilityObj: object) {
    if (facilityObj != null) {
      this.loading = true;
      this.equipmentService.transferEquipment(JSON.stringify(facilityObj))
        .subscribe((result: any) => {
            this.loading = false;
            this.GetFacilityEquipmentMassTransferRight();
            this.GetFacilityEquipmentMassTransferLeft();
            this.changeDetectorRef.detectChanges();
            this.Header = "Success";
            this.Content = "Equipment successfully transferred!";
            this.displayModal = true
          },
          (respose: Response) => {
            this.loading = false;
            this.changeDetectorRef.detectChanges();
            this.Header = "Error";
            this.Content = "Equipment transfer Failed.";
            this.displayModal = true;
          }
        );
    }
  }
  closeClick(eventId: string) {
    this.displayModal = false;
  }
  resetLeft() {
    this.firstLeft = 0;
  }
  resetRight() {
    this.firstRight = 0;
  }
}
